module.exports = __webpack_public_path__ + "static/media/RadiusAllsidesBlue.f9ce379a.svg";